import {
  toDateFromHoursMinutesSeconds,
  toIntlDateTimeFormat,
} from '@zedoc/date';

// NOTE: Copy of a helper method from packlets/models/Variable.js
const getDisplayValueDate = (format, value) => {
  switch (format) {
    case 'time':
      return toDateFromHoursMinutesSeconds(value);
    default:
      return new Date(value);
  }
};

// NOTE: Copy of a helper method from packlets/models/Variable.js
const getDisplayValueDateFormatOptions = (format) => {
  switch (format) {
    case 'date':
    case 'birth-date': {
      return {
        dateStyle: 'short',
      };
    }
    case 'partial-date': {
      return {
        year: 'numeric',
        month: 'numeric',
      };
    }
    case 'time':
      return {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      };
    case 'year':
      return {
        year: 'numeric',
      };
    default:
      return {};
  }
};

// NOTE: For now we only support formatting for dates that match "YYYY-MM-DD"
export const formatVariableValue = ({ value, schema, language }) => {
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;

  if (
    value &&
    isoDateRegex.test(value) &&
    schema &&
    schema.type === 'string' &&
    (schema.format === 'date' ||
      schema.format === 'birth-date' ||
      schema.format === 'partial-date' ||
      schema.format === 'year' ||
      schema.format === 'time' ||
      schema.format === 'instant')
  ) {
    return toIntlDateTimeFormat(
      language,
      getDisplayValueDate(schema.format, value),
      getDisplayValueDateFormatOptions(schema.format),
    );
  }

  return value;
};
